import { render, staticRenderFns } from "./NoData.vue?vue&type=template&id=1f8ad05e&scoped=true&"
import script from "./NoData.vue?vue&type=script&lang=ts&"
export * from "./NoData.vue?vue&type=script&lang=ts&"
import style0 from "./NoData.vue?vue&type=style&index=0&id=1f8ad05e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8ad05e",
  null
  
)

export default component.exports